import Badge from "@mui/material/Badge";
import { withDisplayName } from "../../utils/displayName";

withDisplayName(Badge, "Badge");
export default Badge;
export type { BadgeProps } from "@mui/material/Badge";
